'use client'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonLink } from '@kiao-voice/ui-kit'
import { InkHero } from '../../components/site/ink-hero'
import { smoothScrollToAnchor } from '../../lib/smooth-scroll'
import { trackSiteLinkClicked } from '@/lib/analytics'

/**
 * 字幕/逐字稿頁首屏。標題本來就長，字級上限收到 56px 讓桌機剛好兩行。
 *
 * 主鈕指向 `#try`，那一區在 PR-3 才進頁面；在它之前這個錨點不存在，
 * `smoothScrollToAnchor` 找不到目標就保留瀏覽器預設行為（不會壞，只是不捲動）。
 */
export function TranscriptionHero() {
  const { t } = useTranslation(['web'])

  return (
    <InkHero
      eyebrow={t('web:transcriptionPage.hero.eyebrow')}
      titleKey="web:transcriptionPage.hero.title"
      lead={t('web:transcriptionPage.hero.lead')}
      titleSize="capped"
      actions={
        <>
          <ButtonLink
            variant="brand"
            size="marketing"
            href="#try"
            onClick={(event) => {
              trackSiteLinkClicked('hero', '#try')
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:transcriptionPage.hero.primaryCta')}
          </ButtonLink>
          <ButtonLink
            variant="secondary"
            size="marketing"
            href="#uses"
            onClick={(event) => {
              trackSiteLinkClicked('hero', '#uses')
              smoothScrollToAnchor(event)
            }}
          >
            {t('web:transcriptionPage.hero.secondaryCta')}
          </ButtonLink>
        </>
      }
    />
  )
}
